var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.9799 23.9154L14.8999 12.3954L2.9799 0.875426C2.65501 0.56247 2.21911 0.391395 1.76808 0.399834C1.31706 0.408273 0.887859 0.595536 0.574903 0.920426C0.261948 1.24532 0.0908727 1.68122 0.0993118 2.13225C0.107751 2.58327 0.295013 3.01247 0.619904 3.32543L10.0099 12.3954L0.619904 21.4754C0.295013 21.7884 0.107751 22.2176 0.0993118 22.6686C0.0908727 23.1196 0.261948 23.5555 0.574903 23.8804C0.887859 24.2053 1.31706 24.3926 1.76808 24.401C2.21911 24.4095 2.65501 24.2384 2.9799 23.9254V23.9154Z","fill":"#8C8789"}));
}

Chevron.defaultProps = {"width":"15","height":"25","viewBox":"0 0 15 25","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
